import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function convertToEokWon(number: number): string {
  if (typeof number !== "number" || isNaN(number)) {
    return "0";
  }

  // Convert to 억 (100 million)
  const eok = number / 100000000;

  // Round to 1 decimal place
  const rounded = Math.round(eok * 10) / 10;

  return rounded.toString();
}

export function convertToManWon(number: number): string {
  if (typeof number !== "number" || isNaN(number)) {
    return "0";
  }

  // Convert to 만 (10,000)
  const man = number / 10000;

  // Round down to 1 decimal place
  const rounded = Math.floor(man * 10) / 10;

  return rounded.toString();
}
